<template>
<v-form ref="f" lazy-validation v-model="valid">
	<v-container v-if="hotels.length">
		<v-row >
			<v-col class="pt-6 mt-1 pb-0" cols="12" sm="6" >
				<span class="headline">Потребление коммунальных услуг</span>
			</v-col>
			<v-col class="pb-0" cols="12" sm="6" >
				<a-hotel-select v-model="hotelCode"
						  	 :hotels="hotels"
						  	 :loading="hotelLoading"
						  	 @change="getValues">
				</a-hotel-select>
			</v-col>
		</v-row>
		<v-row >
			<v-col class="pt-0" cols="4" sm="2" >
				<span class="subtitle-1">Показатель</span>
			</v-col>
			<v-col cols="4" sm="2" class="text-center">
				<span class="subtitle-1">Ед.</span>
			</v-col>
			<v-col cols="4" sm="2" class="text-center" v-if="$vuetify.breakpoint.smAndUp">
				<span class="subtitle-1">{{ lastMonthFormat }}</span>
			</v-col>
			<v-col cols="4" sm="2" class="text-center" v-if="$vuetify.breakpoint.smAndUp">
				<span class="subtitle-1">{{ monthFormat }}</span>
			</v-col>
		</v-row>

		<v-row v-for="(line, key) in form" :key="key">
			<v-col class="py-2" cols="4" sm="2" >
				<v-tooltip bottom max-width="500" v-if="line.tooltip">
					<template v-slot:activator="{ on }">
						<span class="subtitle-1" v-on="on">{{ line.name }}</span>
					</template>
					<span>{{ line.tooltip }}</span>
				</v-tooltip>
				<span class="subtitle-1" v-else>{{ line.name }}</span>
			</v-col>
			<v-col cols="4" sm="2" class="text-center py-2">
				<span class="subtitle-1">{{ line.unit }}</span>
			</v-col>
			<v-col class="py-0" cols="4" sm="2" >
				<a-number-field v-model="line.cons.value[0]"
							 :loading="valuesLoading"
							 class="my-0 py-0"
							 digits=2
							 readonly>
				</a-number-field>
			</v-col>
			<v-col class="py-0" cols="4" sm="2" >
				<a-number-field v-model="line.cons.value[1]"
							 :loading="valuesLoading"
							 class="my-0 py-0"
							 @input.native="dataChanged = true"
							 digits=2>
				</a-number-field>
			</v-col>
		</v-row>
		<v-row>
			<v-col class="py-0" cols="4" sm="2" >
				<div class="mt-4">
					<span class="subtitle-1">Итого</span>
				</div>
			</v-col>
			<v-col class="py-0" cols="4" sm="2" >
			</v-col>
			<v-col class="py-0" cols="4" sm="2" >
				<a-number-field v-model="total[0]"
							 readonly
							 prepend-icon="functions"
							 :loading="valuesLoading"
							 digits=2>
				</a-number-field>
			</v-col>
			<v-col class="py-0" cols="4" sm="2" >
				<a-number-field v-model="total[1]"
							 readonly
							 prepend-icon="functions"
							 :loading="valuesLoading"
							 digits=2>
				</a-number-field>
			</v-col>
		</v-row>

		<v-row >
			<v-col class="pb-0 pt-0" cols="12" >
				<v-btn color="primary"
					   class="ml-0"
					   :disabled="!dataChanged"
					   @click="validate">
					Сохранить
				</v-btn>
			</v-col>
		</v-row>
	</v-container>
	<v-container v-else>
		<v-row>
			<v-col>
				<p class="subtitle-1">
					Нет доступных P&L отчетов
				</p>
			</v-col>
		</v-row>
	</v-container>
	<v-dialog	v-model="dialogConfirm.show"
			  	persistent
  			  	max-width="600">
		<v-card>
	  		<v-card-title class="headline">
				Подтверждение
			</v-card-title>
	        <v-card-text>

				<v-row>
					<v-col cols="12">
						<span class="text--primary" v-html="dialogConfirm.html"></span>
					</v-col>
					<v-col cols="12" class="mb-4">
						<span class="text--primary">Вы уверены, что ввели коректные данные?</span>
					</v-col>
				</v-row>

				<v-btn class="mr-2" color="primary" @click="send">
					Да
				</v-btn>
				<v-btn class="mx-2" color="secondary" @click="dialogConfirm.show = false">
					Назад
				</v-btn>
	        </v-card-text>
      	</v-card>
	</v-dialog>
</v-form>
</template>

<script>
	import _ from 'lodash'
	import aNumberField from '../../base/ANumberField.vue'
	import aHotelSelect from '../../base/AHotelSelect.vue'
	import {api} from '../../../lib/api'
	import {getMonthName, toNum, toStr} from '../../../js/common.js'

	export default {
		components: {
			aNumberField,
			aHotelSelect
		},
		data: () => ({
			valid: false,
			dataChanged: false,
			hotelCode: '',
			form: {
				el: {
					name: 'Электричество',
					unit: 'кВт*ч',
					cons: {
						code: 1851,
						value: ['', '']
					}
				},
				gas: {
					name: 'Газ',
					unit: 'м3',
					cons: {
						code: 1852,
						value: ['', '']
					}
				},
				steam: {
					name: 'Отопление',
					unit: 'ГКал',
					cons: {
						code: 1854,
						value: ['', '']
					}
				},
				water: {
					name: 'Вода',
					unit: 'м3',
					cons: {
						code: 1855,
						value: ['', '']
					}
				},
				sewer: {
					name: 'Канализация',
					unit: 'м3',
					cons: {
						code: 1856,
						value: ['', '']
					}
				},
			},
			dc: 50,
			hotels: null,
			valuesLoading: false,
			hotelLoading: false,
			dialogConfirm: {
				show: false,
				html: ''
			}
		}),
		computed: {
			total() {
				let s = [0, 0]
				for (let line in this.form) {
					s[0] += toNum(this.form[line].cons.value[0])
					s[1] += toNum(this.form[line].cons.value[1])
				}
				s[0] = toStr(s[0], 2)
				s[1] = toStr(s[1], 2)

				return s
			},
			selectedHotel() {
				let index = this.hotels.map(hotel => (hotel.code || null)).indexOf(this.hotelCode)
				return this.hotels[index]
			},
			month() {
				if (this.selectedHotel && this.selectedHotel.month) return this.selectedHotel.month
				else return undefined
			},
			monthFormat() {
				if (this.month) return getMonthName(this.month.substr(5, 2), 'Ul')
				else return undefined
			},
			lastMonthFormat() {
				if (!this.month) return undefined
				let d = this.month.substr(5, 2) - 1
				if (d == 0) d = 12
				return getMonthName(d, 'Ul')
			}
		},
		created() {
			if (this.$store.getters.userHo) {
				this.hotels = this.$store.getters.allHotels
			}
			else {
				this.hotels = this.$store.getters.userHotels
			}

			this.hotelCode = this.$store.getters.selectedHotelCode || this.hotels[0].code
			// this.hotelCode = 'TEST'

			this.apiFirstCall()
		},
		methods: {
			validate() {
				if (!this.$refs.f.validate()) return

				let notices = [];

				for (let line in this.form) {
					let s1 = toNum(this.form[line].cons.value[1])
					let s0 = toNum(this.form[line].cons.value[0])

					if (s0 > 0 && s1 == 0) {
						notices.push('Вы не ввели потребление по строке ' + this.form[line].name.toLowerCase() + ', хотя в прошлом месяце вводили.')
					}
				}

				if (notices.length) {
					this.dialogConfirm.show = true
					this.dialogConfirm.html = '<p>' + notices.join('</p><p>') + '</p>'
				}
				else {
					this.send()
				}
			},
			send() {
				this.dialogConfirm.show = false
				this.$store.dispatch('dialogLoadingStart')

				api.post('pl/set_hod_data', {
					form: this.trimmedForm(),
					hotelCode: this.hotelCode,
					month: this.selectedHotel.month,
					dc: this.dc,
					readyDept: 'ut'
				})
				.then(response => {

					this.$store.dispatch('dialogLoadingStop')
					this.$store.dispatch('dialogDone')
					this.dataChanged = false

				}, error => {})
			},
			apiFirstCall() {
				this.hotelLoading = true
				api.post('pl/get_pending_report_month', { hotels: this.hotels })
				.then(response => {
					this.hotelLoading = false

					this.hotels = response.data.hotels
					this.hotels = this.hotels.filter(hotel => !!hotel.month)

					if (this.hotels.length == 0) return

					this.hotelCode = this.$store.getters.selectedHotelCode || this.hotels[0].code
					// this.hotelCode = 'TEST'
					this.getValues()

				}, error => {})
			},
			getValues(hotelCode) {
				this.valuesLoading = true

				// if (!hotelCode) hotelCode = this.hotelCode
				// let index = this.hotels.map(hotel => (hotel.code || null)).indexOf(hotelCode)
				// let selectedHotel = this.hotels[index]
				// let month = selectedHotel.month

				api.post('pl/get_hod_data', {
					form: this.trimmedForm(),
					hotelCode: this.hotelCode,
					month: this.selectedHotel.month,
					dc: this.dc,
				})
				.then(response => {
					this.valuesLoading = false

					for (let line in this.form) {
						this.form[line].cons.value = response.data.form[line].cons.value
					}
					this.$refs.f.resetValidation()
					this.dataChanged = false

				}, error => {})
			},
			trimmedForm() {
				let newForm = _.cloneDeep(this.form)

				for (let line in newForm) {
					for (let prop in newForm[line]) {
						if (prop != 'cons') {
							delete newForm[line][prop]
						}
					}
				}

				return newForm
			}
		}
	}
</script>
